import { FaArrowRight } from 'react-icons/fa'
import { Link } from 'react-router-dom'

const AddToRunsheetToast = ({ documentIds, runsheetIds }) => {
    return (
        <>
            <div>
                Successfully added
                {' '}
                {documentIds.length}
                {' '}
                {documentIds.length > 1 ? 'documents' : 'document'}
                {' '}
                to the selected
                {' '}
                {runsheetIds.length > 1 ? 'runsheets' : 'runsheet'}
            </div>
            {runsheetIds.length === 1 && 
                <Link
                    className="btn btn-sm btn-primary btn-block mt-2 flex items-center justify-center"
                    to={`/runsheet/${runsheetIds[0]}`}>
                    <span>Go to Runsheet</span>
                    <FaArrowRight className="ml-2 mb-1" />
                </Link>
            }
        </>
    )
}

export default AddToRunsheetToast
